<template>
  <b-overlay
    id="overlay-background"
    :show="moduleloader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-alert
      variant="primary"
      show
    >
      <h4
        v-if="processModule.depends_on === 0"
        class="alert-heading"
      >
        {{ processModule.module_title }}
      </h4>
      <div class="alert-body scroll-div">
        <b-list-group
          flush
          class="awaitlist"
        >
          <b-list-group-item>
            <dropdown-field
              v-if="!busy"
              :select-type="1"
              :filterable="false"
              :label-translation="true"
              :form-group-label="formGroupLabel"
              :module-i-d="processModule.id"
              :select-model="currentModule === 3 ? processModule.module_settings.letter_template_id : processModule.module_settings.email_template_id"
              :select-options="currentModule === 3 ? letterTemplates : emailTemplates"
              :special-options="[]"
              :data="{}"
              :variable="{}"
              :depends-on="processModule.depends_on"
            />
          </b-list-group-item>
          <b-list-group-item
            v-if="newCustomVariables.length > 0"
            id="default-custom-variables"
            class="list-variable-item"
          >
            <b-row
              class="variables-row"
            >
              <b-col
                v-for="(data,index) in newCustomVariables"
                :key="index"
                cols="12"
                :md="processModule.depends_on > 0 ? '12' : '6'"
                :lg="processModule.depends_on > 0 ? '12' : '6'"
                class="variable-col"
              >
                <b-form-group
                  :label="data.id"
                  label-for="email_template"
                  :aria-hidden="busy ? 'true' : null"
                >
                  <div :id="'div-wrapper-'+processModule.id+'-'+data.id">
                    <v-select
                      v-model="data.value"
                      :disabled="busy"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="templateVariableOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      :input-id="'letter-template-'+data.id"
                      :class="'letter-template-'+data.id"
                      @input="changeVariable(0, processModule.id, $event, data, index, data.id)"
                    >
                      <template
                        slot="option"
                        slot-scope="option"
                      >
                        <div :class="assignClass(option.value) ? 'autofik' : ''">
                          {{ option.label }}
                        </div>
                      </template>
                    </v-select>
                    <b-row
                      :id="'date-'+processModule.id+'-'+data.id"
                      class="showdates"
                    >
                      <b-col md="12">
                        <b-form-group
                          label="Select number of days after letter generation"
                          label-for="letter_template"
                        >
                          <b-form-input
                            :id="'noOfDays-'+processModule.id+'-'+data.id"
                            v-model="data.field"
                            type="number"
                            @change="getTheObject(processModule.condition, processModule.depends_on)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row
                      :id="'currency-conversion-'+processModule.id+'-'+data.id"
                      class="showdates"
                    >
                      <b-col md="12">
                        <b-form-group
                          label="Select The Statement"
                          :label-for="'currency-statement-'+processModule.id+'-'+data.id"
                        >
                          <v-select
                            v-model="data.fields[0]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="statementsOptions"
                            :reduce="val => val.value"
                            :clearable="false"
                            :input-id="'currency-statement-'+processModule.id+'-'+data.id"
                            @input="getTheObject(processModule.condition, processModule.depends_on)"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="12">
                        <b-form-group
                          label="Convert to Currency"
                          :label-for="'convert-currency-'+processModule.id+'-'+data.id"
                        >
                          <v-select
                            v-model="data.fields[1]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="convertCurrenciesOptions"
                            :reduce="val => val.value"
                            :clearable="false"
                            :input-id="'convert-currency-'+processModule.id+'-'+data.id"
                            @input="getTheObject(processModule.condition, processModule.depends_on)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row
                      :id="'interestrate-percentage-'+processModule.id+'-'+data.id"
                      class="showdates"
                    >
                      <b-col md="12">
                        <b-form-group
                          label="Select Base Document Type"
                          :label-for="'base-document-types-'+processModule.id+'-'+data.id"
                        >
                          <v-select
                            v-model="data.fields[0]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="baseDocumentTypes"
                            :reduce="val => val.value"
                            :clearable="false"
                            multiple
                            :input-id="'base-document-types-'+processModule.id+'-'+data.id"
                            @input="getTheObject(processModule.condition, processModule.depends_on)"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="12">
                        <b-form-group
                          label="To Fetch"
                          :label-for="'fetching-document-'+processModule.id+'-'+data.id"
                        >
                          <v-select
                            v-model="data.fields[1]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="fetchingDocumentsOptions"
                            :reduce="val => val.value"
                            :clearable="false"
                            :input-id="'fetching-document-'+processModule.id+'-'+data.id"
                            @input="getTheObject(processModule.condition, processModule.depends_on)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row
                      :id="'run-date-'+processModule.id+'-'+data.id"
                      class="showdates"
                    >
                      <b-col md="12">
                        <b-form-group
                          label="Select Module"
                          :label-for="'prev-module-dropdown-'+processModule.id+'-'+data.id"
                        >
                          <v-select
                            v-model="data.fields[0]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="showPrevModuleOptions"
                            :reduce="val => val.value"
                            :clearable="false"
                            :input-id="'prev-module-dropdown-'+processModule.id+'-'+data.id"
                            @input="getTheObject(processModule.condition, processModule.depends_on)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="data.mappable.value"
                      :id="'conditional-mappable-'+processModule.id+'-'+data.id"
                      class="showdates"
                    >
                      <copy-conditional-mappables
                        v-if="data.mappable.value"
                        :ref="`conditionalChild-${processModule.id}-${data.id}`"
                        :conditions="conditions"
                        :data="data.id"
                        :busy="busy"
                        :statement-condition-i-d="statementConditionID"
                        :client-type-condition-i-d="clientTypeConditionID"
                        :interest-type-condition-i-d="interestTypeConditionID"
                        :airports-data="AirportsData"
                        :email-var="{}"
                        :convert-currencies-options="convertCurrenciesOptions"
                        :assign-class="assignClass"
                        :prev-module-options="showPrevModuleOptions"
                        :statements-options="statementsOptions"
                        :mappable-id="data.id"
                        :template-variable-options="templateVariableOptions.filter(item => item.value !== 'conditional_mappable')"
                        :component-object="data.mappable.data"
                        :remove-error-msg="removeErrorMsg"
                        :letter-templates="letterTemplates"
                        :statements="statements"
                        :payment-email-template="paymentEmailTemplate"
                        :module-type="currentModule"
                        :client-collection-type-i-d="clientCollectionTypeID"
                        @childData="getConditions"
                      />
                    </b-row>
                    <b-row
                      :id="'letter-sent-date-'+processModule.id+'-'+data.id"
                      class="showdates"
                    >
                      <b-col
                        :id="'case-presentation-statements-'+processModule.id+'-'+data.id"
                        md="12"
                      >
                        <b-form-group
                          label="Collection Fee Statement"
                          :label-for="'case-presentation-'+processModule.id+'-'+data.id"
                        >
                          <v-select
                            v-model="data.fields[1]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="statements"
                            :reduce="val => val.value"
                            :clearable="false"
                            :input-id="'case-presentation-'+processModule.id+'-'+data.id"
                            @input="getTheObject(processModule.condition, processModule.depends_on)"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="12">
                        <b-form-group
                          label="Select Letter Template"
                          :label-for="'select-letter-template-'+processModule.id+'-'+data.id"
                        >
                          <v-select
                            v-model="data.fields[0]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="letterTemplates"
                            :reduce="val => val.value"
                            :clearable="false"
                            multiple
                            :input-id="'select-letter-template-'+processModule.id+'-'+data.id"
                            @input="getTheObject(processModule.condition, processModule.depends_on)"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        :id="'letter-sent-date-order-'+processModule.id+'-'+data.id"
                        md="12"
                      >
                        <b-form-group
                          label="To Fetch"
                          :label-for="'fetching-letters-'+processModule.id+'-'+data.id"
                        >
                          <v-select
                            v-model="data.fields[1]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="fetchingLettersOptions"
                            :reduce="val => val.value"
                            :clearable="false"
                            :input-id="'fetching-letters-'+processModule.id+'-'+data.id"
                            @input="getTheObject(processModule.condition, processModule.depends_on)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row
                      :id="'free-text-'+processModule.id+'-'+data.id"
                      class="showdates"
                    >
                      <b-col md="12">
                        <b-form-group
                          v-if="data.value === 'debtia.freeText'"
                          label="Free Text Note"
                          :label-for="'freeTextField-'+processModule.id+'-'+data.id"
                        >
                          <b-form-input
                            :id="'freeTextField-'+processModule.id+'-'+data.id"
                            v-model="data.fields[0]"
                            @change="getTheObject(processModule.condition, processModule.depends_on)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row
                      :id="'payment-link-'+processModule.id+'-'+data.id"
                      class="showdates"
                    >
                      <div
                        class="amount-period-base-divs"
                      >
                        <b-col
                          class="optionsClass"
                          md="12"
                        >
                          <b-form-checkbox
                            :id="'amount_based_plan-'+processModule.id+'-'+data.id"
                            v-model="data.fields[0]"
                            class="custom-control-primary"
                            @change="updateInstallmentPlanFields($event, data.id, 'amount_based_plan', index)"
                          >
                            {{ $t('DEBTIA_AMOUNT_BASE_PLAN') }}
                          </b-form-checkbox>
                        </b-col>
                        <b-col
                          :id="'col-min_amount-'+processModule.id+'-'+data.id"
                          :style="data.fields[1] !== null ? 'display: block' : 'display: none'"
                          md="12"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_MIN_AMOUNT')"
                            :label-for="'min_amount-'+processModule.id+'-'+data.id"
                          >
                            <!-- <validation-provider
                              #default="{ errors }"
                              name="Min. Amount"
                              rules="required"
                            > -->
                            <b-form-input
                              :id="'min_amount-'+processModule.id+'-'+data.id"
                              v-model="data.fields[1]"
                              type="number"
                              placeholder="Min. Amount"
                              :input-id="'min_amount-'+processModule.id+'-'+data.id"
                              @input="updateInstallmentPlanFields($event, data.id, 'min_amount', index), removeErrorBorder('min_amount-'+processModule.id+'-'+data.id, 0)"
                            />
                            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                            <small
                              v-if="minAmountError"
                              class="text-danger dd"
                            >The min amount must be at least 100</small>
                            <!-- </validation-provider> -->
                          </b-form-group>
                        </b-col>
                      </div>
                      <div
                        class="amount-period-base-divs"
                      >
                        <b-col
                          class="optionsClass"
                          md="12"
                        >
                          <b-form-checkbox
                            :id="'period_based_plan-'+processModule.id+'-'+data.id"
                            v-model="data.fields[2]"
                            class="custom-control-primary"
                            @change="updateInstallmentPlanFields($event, data.id, 'period_based_plan', index)"
                          >
                            {{ $t('DEBTIA_PERIOD_BASE_PLAN') }}
                          </b-form-checkbox>
                        </b-col>
                        <b-col
                          :id="'col-max_months-'+processModule.id+'-'+data.id"
                          :style="data.fields[3] !== null ? 'display: block' : 'display: none'"
                          md="12"
                        >
                          <b-form-group
                            :label="$t('DEBTIA_MAX_MONTH')"
                            :label-for="'max_months-'+processModule.id+'-'+data.id"
                          >
                            <!-- <validation-provider
                              #default="{ errors }"
                              name="Max. Months"
                              rules="required"
                            > -->
                            <b-form-input
                              :id="'max_months-'+processModule.id+'-'+data.id"
                              v-model="data.fields[3]"
                              index
                              type="number"
                              placeholder="Max. Month"
                              :input-id="'max_months-'+data.id"
                              @input="updateInstallmentPlanFields($event, data.id, 'max_months', index), removeErrorBorder('max_months-'+processModule.id+'-'+data.id, 0)"
                            />
                            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                            <small
                              v-if="maxMonthsError"
                              class="text-danger dd"
                            >The max months must be at least 1.</small>
                            <!-- </validation-provider> -->
                          </b-form-group>
                        </b-col>
                      </div>
                      <b-col
                        :id="'col-interest_free_months-'+processModule.id+'-'+data.id"
                        :style="data.fields[4] !== null ? 'display: block' : 'display: none'"
                        md="12"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_INTEREST_FREE_MONTHS')"
                          :label-for="'interest_free_months-'+processModule.id+'-'+data.id"
                        >
                          <!-- <validation-provider
                            #default="{ errors }"
                            name="Interest Free Months"
                            rules="required"
                          > -->
                          <b-form-input
                            :id="'interest_free_months-'+processModule.id+'-'+data.id"
                            v-model="data.fields[4]"
                            type="number"
                            placeholder="Interest Free Months"
                            @change="updateInstallmentPlanFields($event, data.id, 'interest_free_months', index), removeErrorBorder('interest_free_months-'+processModule.id+'-'+data.id, 0)"
                          />
                          <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                          <small
                            v-if="interestFreeMonthsError"
                            class="text-danger"
                          >{{ $t('DEBTIA_INTEREST_FREE_POSITIVE') }}</small>
                          <!-- </validation-provider> -->
                        </b-form-group>
                      </b-col>
                      <b-col
                        :id="'col-payment_date-'+processModule.id+'-'+data.id"
                        :style="data.fields[5] !== null ? 'display: block' : 'display: none'"
                        md="12"
                      >
                        <!-- <validation-provider
                          #default="{ errors }"
                          name="Installment Start Date"
                          rules="required"
                        > -->
                        <b-form-group
                          :label="$t('DEBTIA_INSTALLMENT_START_DATE')"
                          :label-for="'payment_date-'+processModule.id+'-'+data.id"
                        >
                          <v-select
                            :id="'payment_date-'+processModule.id+'-'+data.id"
                            ref="installmentStartDate"
                            v-model="data.fields[5]"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="paymentDateOptions"
                            :reduce="val => val.value"
                            :clearable="false"
                            @input="updateInstallmentPlanFields($event, data.id, 'payment_date', index), removeErrorBorder('payment_date-'+processModule.id+'-'+data.id, 1)"
                          />
                          <!-- <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                            {{ errors[0] }}
                          </b-form-invalid-feedback> -->
                        </b-form-group>
                        <!-- </validation-provider> -->
                      </b-col>
                    </b-row>
                  </div>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                :md="processModule.depends_on > 0 ? '12' : '6'"
                :lg="processModule.depends_on > 0 ? '12' : '6'"
                class="variable-col"
              >
                <b-form-group
                  label="Recipient"
                >
                  <v-select
                    v-model="processModule.module_settings.receipients.value"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="ReceipientOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    @input="getTheObject(processModule.condition, processModule.depends_on)"
                  />
                </b-form-group>
                <b-form-group
                  v-if="processModule.module_settings.receipients.value === 'debtia.receipientsContact'"
                  label="Contacts"
                >
                  <v-select
                    v-model="processModule.module_settings.receipients.contact_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="contactOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    @input="getTheObject(processModule.condition, processModule.depends_on)"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item
            v-else
          >
            {{ 'Data is loading.' }}
          </b-list-group-item>
          <b-list-group-item>
            {{ $t('DEBTIA_FILE_CATEGORIES') }}
            <v-select
              v-model="processModule.module_settings.file_groups"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="fileCategories"
              :reduce="val => val.value"
              :clearable="false"
              multiple
              @input="getTheObject(processModule.condition, processModule.depends_on)"
            />
          </b-list-group-item>
          <b-list-group-item
            v-if="currentModule === 3"
          >
            <b-form-checkbox
              :id="'allow-skip-email-'+processModule.id"
              v-model="processModule.module_settings.skip_email"
              class="custom-control-primary"
              @change="getTheObject(processModule.condition, processModule.depends_on)"
            >
              {{ $t('DEBTIA_SKIP_SENDING_EMAIL') }}
            </b-form-checkbox>
          </b-list-group-item>

          <b-list-group-item
            v-if="currentModule === 3"
          >
            <b-form-group
              :label="$t('DEBTIA_WHICH_DAYS_CAN_IT_SEND')"
              label-for="send-days"
            >
              <b-row>
                <b-col
                  v-for="day in daysOptions"
                  :key="day.value"
                  cols="8"
                  md="4"
                  class="mb-2"
                >
                  <b-form-checkbox
                    :checked="selectedDays.includes(day.value)"
                    @change="toggleDay(day.value)"
                  >
                    {{ day.label }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-group>
          </b-list-group-item>

        </b-list-group>
      </div>
    </b-alert>
  </b-overlay>
</template>
<!-- eslint-disable no-param-reassign -->
<script>
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BAlert, BListGroup, BListGroupItem,
  // BCard,
  BFormGroup,
  BFormInput,
  BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'
import { EventBus } from '@/event-bus'
import vSelect from 'vue-select'
import axios from '@axios'
// import { EventBus } from '@/event-bus'
import axiosletter from '../../../libs/axiosletter'
import axiosEmail from '../../../libs/axiosemail'
import DropdownField from './DropdownField.vue'
// import SelectField from './fields/SelectField.vue'
import CopyConditionalMappables from './CopyConditionalMappables.vue'

export default {
  inject: ['sharedState'], // Inject the reactive shared state
  components: {
    BRow,
    BCol,
    BAlert,
    BListGroup,
    BListGroupItem,
    DropdownField,
    // SelectField,
    // BCard,
    BOverlay,
    BFormGroup,
    BFormInput,
    vSelect,
    CopyConditionalMappables,
    BFormCheckbox,
  },
  props: {
    currentModule: {
      type: Number,
      required: true,
    },
    formGroupLabel: {
      type: String,
      required: true,
    },
    processModule: {
      type: Object,
      required: true,
    },
    letterTemplates: {
      type: Array,
      required: true,
    },
    contactOptions: {
      type: Array,
      default: null,
      required: false,
    },
    fileCategories: {
      type: Array,
      required: true,
    },
    specialOptions: {
      type: Array,
      required: true,
    },
    templateVariableOptions: {
      type: Array,
      required: true,
    },
    clientId: {
      type: String,
      required: true,
    },
    secret: {
      type: String,
      required: true,
    },
    emailTemplates: {
      type: Array,
      required: true,
    },
    prevModuleOptions: {
      type: Array,
      required: true,
    },
    paymentEmailTemplate: {
      type: [Number, String],
      required: false, // Not required
      default: '', // Optional default value
    },
  },
  data() {
    return {
      moduleloader: false,
      busy: false,
      newCustomVariables: [],
      lettervariables: {},
      fileCategory: [],
      convertCurrenciesOptions: [],
      statementsOptions: [],
      baseDocumentTypes: [
        { label: 'Invoice (Faktura)', value: 1 },
        { label: 'Court Verdict (Dom) ', value: 2 },
        { label: 'Promissory note (Gældsbrev)', value: 3 },
        { label: 'Undefined/Other (Andet)', value: 4 },
      ],
      ReceipientOptions: [
        { label: 'Creditor', value: 'debtia.receipientsClient' },
        { label: 'Debtor(s)', value: 'debtia.receipientsDebtor' },
        { label: 'Partner (s)', value: 'debtia.receipientsPartner' },
        { label: 'Court', value: 'debtia.receipientsCourt' },
        { label: 'Contact', value: 'debtia.receipientsContact' },
      ],
      fetchingDocumentsOptions: [
        { label: 'First Base Document', value: 'first' },
        { label: 'Last Base Document', value: 'last' },
      ],
      componentObject: {
        condition_mappable: true,
        functional_value: null,
        condition_id: null, // req
        condition_value: 0, // req (when statements is selected then the value of the input field)
        subStatementValue: null,
        condition_operator_id: null, // req
        true_value: {},
        false_value: {},
        custom_variable_id: 0,
        custom_option_id: 0,
        custom_variable_value: 'debtor',
        dacustom_variable_value: '',
        file_category_id: 0,
        debt_case_group_id: 0,
        sub_statements: [],
        dateOption: 1,
        interest_type_condition: '',
        letterTemplates: this.letterTemplates,
        statements: [],
        currentTemplateId: null,
        currentTemplateTitle: '',
        previousTemplateVars: [],
        client_collection_type: '',
        client_type: '',
        fieldFilledLoaded: false,
      },
      fetchingLettersOptions: [
        { label: 'First Letter', value: 'asc' },
        { label: 'Last Letter', value: 'desc' },
      ],
      // customVariables: [],
      conditions: [],
      AirportsData: [],
      statements: [],
      statementConditionID: 0,
      interestTypeConditionID: '',
      currentFileCategoies: [],
      baseDocumentAttachments: false,
      receipientVars: {
        'debtia.receipientsClient': 'debtiaReceipientsClient',
        'debtia.receipientsDebtor': 'debtiaReceipientsDebtors',
        'debtia.receipientsPartner': 'debtiaReceipientsPartners',
        'debtia.receipientsCourt': 'debtiaReceipientsCourt',
        'debtia.receipientsContact': 'debtiaReceipientsContact',
      },
      fieldObject: {},
      paymentDateOptions: [
        { label: 'Now', value: 'now' },
        { label: 'First day next month', value: 'first_day_next_month' },
      ],
      minAmountError: false,
      maxMonthsError: false,
      interestFreeMonthsError: false,
      installmentStartDate: null,
      interestFreeMonths: '',
      minAmount: '',
      maxMonth: '',
      amountBasePlan: 0,
      periodBasePlan: 0,
      communications_secret: '',
      email_template_id: 0,
      clientCollectionTypeID: 0,
      client_collection_type: '',
      client_type: '',
      clientCollectionTypeOptions: [
        { label: 'Own', value: 'own' },
        { label: 'Foreign', value: 'foreign' },
      ],
      clientTypeConditionID: 0,
      selectedDays: (() => ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
      )(),
      daysOptions: [
        { label: 'Monday', value: 'mon' },
        { label: 'Tuesday', value: 'tue' },
        { label: 'Wednesday', value: 'wed' },
        { label: 'Thursday', value: 'thu' },
        { label: 'Friday', value: 'fri' },
        { label: 'Saturday', value: 'sat' },
        { label: 'Sunday', value: 'sun' },
      ],
    }
  },
  watch: {
    'processModule.module_settings.receipients.value': {
      handler() {
        this.processModule.payload.custom_variables.receipients.contact_id = 0
      },
    },
  },
  async created() {
    // Initialize selectedDays from the API enabled_days object
    if (this.processModule.module_id === 3) {
      const allDayKeys = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
      const enabledDays = this.processModule?.module_settings?.enabled_days
      if (!enabledDays) return
      if (enabledDays) {
        if (enabledDays.all === true) {
          this.selectedDays = [...allDayKeys]
        } else {
          this.selectedDays = allDayKeys.filter(key => enabledDays[key] === true)
        }
      }
    }
    this.currentTemplateId = this.processModule.module_id === 3 ? this.processModule.module_settings.letter_template_id : this.processModule.module_settings.email_template_id
    this.currentTemplateTitle = this.findLabelByValue(this.currentTemplateId)
    /* EventBus.$on('fileCategoriesChnage', categories => {
      this.currentFileCategoies = [...categories]
    }) */
    await this.getCurrencyConversionParams()
    await this.getConditions()
    await this.getPreviousModules(this.processModule.index)
    await this.getStatements()
    this.changeTheVariables(this.processModule.id, this.processModule.module_settings.custom_variables)
  },
  methods: {
    // Toggles a day in selectedDays and rebuilds enabled_days for the payload.
    toggleDay(dayKey) {
      const allDayKeys = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
      const idx = this.selectedDays.indexOf(dayKey)
      if (idx > -1) {
        this.selectedDays.splice(idx, 1)
      } else {
        this.selectedDays.push(dayKey)
      }
      const allSelected = allDayKeys.every(k => this.selectedDays.includes(k))
      if (allSelected) {
        this.processModule.module_settings.enabled_days = { all: true }
      } else {
        // Only include days that are TRUE — no false keys in the payload
        const newEnabledDays = { all: false }
        this.selectedDays.forEach(k => {
          newEnabledDays[k] = true
        })
        this.processModule.module_settings.enabled_days = newEnabledDays
      }
      this.getTheObject(this.processModule.condition, this.processModule.depends_on)
    },
    findLabelByValue(value) {
      let result = ''
      if (this.currentModule === 3) {
        result = this.letterTemplates.find(item => item.value === value)
      } else {
        result = this.emailTemplates.find(item => item.value === value)
      }
      return result ? result.label : null // Returns the label or null if not found
    },
    convertDate(dt) {
      const parts = dt.split('-')
      const year = Number(parts[0])
      const month = Number(parts[1])
      const day = Number(parts[2])
      const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`
      return formattedDate
    },
    setConditionFieldsValue(obj, element) {
      if (element.data.conditions.value === 5) obj.mappable.data.file_category_id = element.data.conditions.fields[0].value
      else if (element.data.conditions.value === 6) obj.mappable.data.debt_case_group_id = element.data.conditions.fields[0].value
      else if (element.data.conditions.value === 10) {
        obj.mappable.data.custom_variable_value = element.data.conditions.fields[0].value
        obj.mappable.data.custom_variable_id = element.data.conditions.fields[1].value
        obj.mappable.data.fieldFilledLoaded = true
      } else if (element.data.conditions.fields[0].label === 'Statements') {
        obj.mappable.data.sub_statements = element.data.conditions.fields[0].value
        obj.mappable.data.subStatementValue = element.data.conditions.fields[1].value
      } else if (element.data.conditions.fields[0]?.collection_type === true) {
        obj.mappable.data.client_collection_type = element.data.conditions.fields[0].value
      } else if (element.data.conditions.fields[0]?.client_type === true) {
        obj.mappable.data.client_type = element.data.conditions.fields[0].value
      } else if (element.data.conditions.fields[0].type === 'select') {
        obj.mappable.data.custom_option_id = element.data.conditions.fields[0].value
      } else if (element.data.conditions.fields[0].type === 'date') {
        obj.mappable.data.dateOption = element.data.conditions.fields[1].value
        obj.mappable.data.custom_variable_value = element.data.conditions.fields[0].value
        obj.mappable.data.dacustom_variable_value = this.convertDate(element.data.conditions.fields[0].value)
      } else {
        obj.mappable.data.custom_variable_value = element.data.conditions.fields[0].value
      }
    },
    changeTheVariables(moduleId, variables) {
      this.currentTemplateTitle = this.currentTemplateTitle === null ? this.findLabelByValue(this.currentTemplateId) : this.currentTemplateTitle
      this.moduleloader = true
      if (this.processModule.newCustomVariables.length === 0) {
        const arr = []
        variables.forEach((element, index) => {
          const obj = {
            id: element.variable,
            value: element.value,
            field: null,
            fields: [],
            mappable: {
              value: false,
              data: {
                condition_mappable: true,
                functional_value: null,
                condition_id: null, // req
                condition_value: 0, // req (when statements is selected then the value of the input field)
                subStatementValue: null,
                condition_operator_id: null, // req
                true_value: {},
                false_value: {},
                custom_variable_id: 0,
                custom_option_id: 0,
                custom_variable_value: 'debtor',
                dacustom_variable_value: '',
                file_category_id: 0,
                debt_case_group_id: 0,
                sub_statements: [],
                dateOption: 1,
                interest_type_condition: '',
                letterTemplates: this.letterTemplates,
                statements: [],
                currentTemplateId: null,
                currentTemplateTitle: '',
                client_collection_type: '',
                client_type: '',
                SubStatementOptions: this.processModule.SubStatementOptions,
                fieldFilledLoaded: false,
              },
            },
          }
          if (element.functional_value) {
            obj.field = element.functional_value
          } else {
          // Initialize an empty array to store the values
            const valuesArray = []
            // Loop through the 'fields' array and extract the 'value' attribute
            if (element.data && element.value !== 'condition_mappable') {
              element.data.fields.forEach(field => {
                valuesArray.push(field.value)
              })
              obj.fields = [...valuesArray]
            }
            if (element.data && element.value === 'condition_mappable') {
              obj.mappable.data.condition_id = element.data.conditions.value
              if (element.data.conditions.fields !== null) {
                this.setConditionFieldsValue(obj, element)
              }
              obj.mappable.data.condition_operator_id = element.data.operator
              obj.mappable.data.true_value = element.mappablePayload.true_value
              obj.mappable.data.false_value = element.mappablePayload.false_value
              // element.mappablePayload = { ...obj.mappable.data }
              setTimeout(() => {
                this.$refs[`conditionalChild-${moduleId}-${element.variable}`][0].changeVariable(element.data.conditions.value, element.variable)
                this.createDefaultYesNo(moduleId, element.data.ifTrue, element.variable, 1)
                this.createDefaultYesNo(moduleId, element.data.ifFalse, element.variable, 0)
              }, 3000)
            }
            if (element.custom_variable) {
              obj.custom_variable = true
              obj.varType = element.varType
            }
          }
          // first attribute down is for the delay to load the element in the DOM
          this.changeVariable(1, moduleId, element.value, obj, index, null)
          // in the end pushing the object in array
          arr.push(obj)
        })
        this.newCustomVariables = [...arr]
        this.processModule.newCustomVariables = this.newCustomVariables
      } else {
        this.newCustomVariables = this.processModule.newCustomVariables
        this.processModule.newCustomVariables.forEach((element, index) => {
          this.changeVariable(1, moduleId, element.value, element, index, null)
        })
      }
      this.processModule.fieldsData = {
        template_id: 0,
        vars: this.newCustomVariables,
      }
      this.previousTemplateVars = [...this.newCustomVariables]
      this.getTheObject(this.processModule.condition, this.processModule.depends_on)
      this.moduleloader = false
    },
    getTheObject(condition, dependsOn) {
      const customVariables = {}
      this.newCustomVariables.forEach(element => {
        if (element.value === 'debtia.currencyConverter') {
          const statementObject = this.statementsOptions.filter(e => e.value === element.fields[0])
          const internalObj = {
            variable: element.value,
            functional_value: null,
            currency_id: element.fields[1],
            statement_id: element.fields[0],
            statement_type: statementObject[0]?.type ?? '',
          }
          customVariables[element.id] = internalObj
        } else if (element.value === 'dato_felt') {
          const internalObj = {
            variable: element.value,
            functional_value: element.field,
          }
          customVariables[element.id] = internalObj
        } else if (element.value === 'interest_rate_percentage') {
          const internalObj = {
            variable: element.value,
            functional_value: null,
            base_types: element.fields[0],
            document_order: element.fields[1],
          }
          customVariables[element.id] = internalObj
        } else if (element.value === 'module_run_date') {
          const internalObj = {
            variable: element.value,
            functional_value: element.fields[0],
          }
          customVariables[element.id] = internalObj
        } else if (element.value === 'letter_sent_date') {
          const filteredData = this.letterTemplates.filter(item => (element.fields.length > 0 ? element.fields[0].includes(item.value) : [])).map(item => ({ id: item.value, title: item.label }))
          const internalObj = {
            variable: element.value,
            functional_value: null,
            letters: filteredData,
            order: element.fields[1],
          }
          customVariables[element.id] = internalObj
        } else if (element.value === 'debtia.case_presentation') {
          const filteredData = this.letterTemplates.filter(item => element.fields[0].includes(item.value)).map(item => ({ id: item.value, title: item.label }))
          const internalObj = {
            variable: element.value,
            functional_value: element.fields[1],
            letters: filteredData,
            order: element.fields[1],
          }
          customVariables[element.id] = internalObj
        } else if (element.value === 'debtia.freeText') {
          const internalObj = {
            variable: element.value,
            functional_value: null,
            free_text_note: element.fields[0],
          }
          customVariables[element.id] = internalObj
        } else if (element.value === 'condition_mappable') {
          customVariables[element.id] = element.mappable.data
        } else if (element?.custom_variable === true) {
          customVariables[element.id] = {
            custom_variable: true,
            functional_value: null,
            variable: element.value,
          }
        } else if (element.value === 'debtia.paymentLink') {
          customVariables[element.id] = {
            variable: 'debtia.paymentLink',
            functional_value: null,
            amount_based_plan: element.fields[0] !== undefined ? element.fields[0] : false,
            min_amount: element.fields[1] !== undefined ? element.fields[1] : null,
            period_based_plan: element.fields[2] !== undefined ? element.fields[2] : false,
            max_months: element.fields[3] !== undefined ? element.fields[3] : null,
            interest_free_months: element.fields[4] !== undefined ? element.fields[4] : null,
            payment_date: element.fields[5] !== undefined ? element.fields[5] : null,
            template_id: element.fields[6] !== undefined ? element.fields[6] : this.paymentEmailTemplate,
            employee_name: element.fields[7] !== undefined ? element.fields[7] : JSON.parse(localStorage.getItem('userData')).data.name,
            module_type: this.currentModule === 3 ? 'letter' : 'email',
          }
        } else {
          customVariables[element.id] = element.value
        }
      })
      this.baseDocumentAttachments = this.processModule.module_settings.file_groups.includes('baseDocuments')
      customVariables.receipients = {
        key: this.receipientVars[this.processModule.module_settings.receipients.value],
        value: this.processModule.module_settings.receipients.value,
        contact_id: this.processModule.module_settings.receipients.contact_id,
      }
      const obj = {
        attach_base_documents: this.baseDocumentAttachments,
        custom_variables: customVariables,
        fileCategory: this.processModule.module_settings.file_groups,
        module_id: this.processModule.module_id,
        module_order: 1,
        condition,
        depends_on: dependsOn,
        skip_email: this.processModule.module_settings.skip_email,
        enabled_days: this.processModule.module_settings.enabled_days,
      }
      /* if ((dependsOn && dependsOn > 0) && (condition === 0 || condition === 1)) {
        obj.condition = condition
        obj.depends_on = dependsOn
      } */
      if (this.processModule.module_id === 3) {
        obj.letter_template_id = this.currentTemplateId
        obj.letter_template_title = this.currentTemplateTitle
      } else {
        obj.email_template_id = this.currentTemplateId
        obj.email_template_title = this.currentTemplateTitle
      }
      this.processModule.payload = obj
      EventBus.$emit('haltProcessCopyBtn', false)
    },
    removeErrorMsg() {
      this.errorMsg = false
    },
    async getCurrencyConversionParams() {
      await axios.get('/settings/get-currency').then(response => {
        if (response.status) {
          this.convertCurrenciesOptions = response.data.data
        }
      })

      await axios.get('/get-all-statement-groups?dropdown=true').then(response => {
        if (response.status) {
          this.statementsOptions = response.data.data
        }
      })
    },
    async getConditions() {
      this.busy = true
      await axios.get('/process/get-conditions').then(response => {
        if (response.status === 200) {
          const conditionsData = response.data.data.variables.map(e => ({
            ...e, label: this.$t(e.label), value: e.value,
          }))
          this.conditions.push(...conditionsData)
          this.AirportsData.push(...response.data.data.airports)
          const conditionID = this.conditions.filter(e => e.label === 'Statements')
          this.statementConditionID = conditionID.length > 0 ? conditionID[0].value : 0
          const interestTypeID = this.conditions.filter(e => e.label === 'Is Interest Type Custom?')
          this.interestTypeConditionID = interestTypeID.length > 0 ? interestTypeID[0].value : 0
          const clientCollectionTypeID = this.conditions.filter(e => e.label === 'Is client Collection Type?')
          this.clientCollectionTypeID = clientCollectionTypeID.length > 0 ? clientCollectionTypeID[0].value : 0
          const clientTypeID = this.conditions.filter(e => e.label === 'Check client type')
          this.clientTypeConditionID = clientTypeID.length > 0 ? clientTypeID[0].value : 0
          this.busy = false
        }
      }).catch(error => console.log(error))
    },
    async getStatements() {
      this.busy = true
      await axios.get('/settings/get-statement-settings').then(response => {
        if (response.status === 200) {
          this.statements = response.data.data.statements.filter(e => e.status === 1 && e.key !== '0000' && e.key !== '9999' && e.key !== '99999').map(e => ({
            label: this.$t(e.da_name), value: e.id,
          }))
          this.busy = false
        }
      }).catch(error => console.log(error))
    },
    turnFieldErrorOn(selector) {
      this.$el.querySelector(selector).classList.add('inputErrorClassField')
    },
    turnSelectErrorOn(selector) {
      const elementHTML = this.$el.querySelector(selector)
      const ancestorWithClass = elementHTML.closest('.vs__dropdown-toggle')
      ancestorWithClass.classList.add('inputErrorClassField')
      // this.$el.querySelector(selector).classList.add('inputErrorClassField')
    },
    mappableTrueFalse(values) {
      this.emptyMappableTrueFalseValue = false
      values.forEach(element => {
        if (this.lettervariables[element.id].true_value.variable === 'module_run_date' && !this.lettervariables[element.id].true_value.functional_value) {
          this.turnSelectErrorOn(`#${element.id}-true_value-module_run_date`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'debtia.currencyConverter' && !this.lettervariables[element.id].true_value.statement_id) {
          this.turnSelectErrorOn(`#${element.id}-true_value-statement_id`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'debtia.currencyConverter' && !this.lettervariables[element.id].true_value.currency_id) {
          this.turnSelectErrorOn(`#${element.id}-true_value-currency_id`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'interest_rate_percentage' && this.lettervariables[element.id].true_value.base_types.length < 1) {
          this.turnSelectErrorOn(`#${element.id}-true_value-base_types`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'interest_rate_percentage' && !this.lettervariables[element.id].true_value.document_order) {
          this.turnSelectErrorOn(`#${element.id}-true_value-document_order`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'module_run_date' && !this.lettervariables[element.id].false_value.functional_value) {
          this.turnSelectErrorOn(`#${element.id}-false_value-module_run_date`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'debtia.currencyConverter' && !this.lettervariables[element.id].false_value.statement_id) {
          this.turnSelectErrorOn(`#${element.id}-false_value-statement_id`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'debtia.currencyConverter' && !this.lettervariables[element.id].false_value.currency_id) {
          this.turnSelectErrorOn(`#${element.id}-false_value-currency_id`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'interest_rate_percentage' && this.lettervariables[element.id].false_value.base_types.length < 1) {
          this.turnSelectErrorOn(`#${element.id}-false_value-base_types`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'interest_rate_percentage' && !this.lettervariables[element.id].false_value.document_order) {
          this.turnSelectErrorOn(`#${element.id}-false_value-document_order`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'letter_sent_date' && this.lettervariables[element.id].true_value.letters.length < 1) {
          this.turnSelectErrorOn(`#${element.id}-true_value-send_letters`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].true_value.variable === 'letter_sent_date' && !this.lettervariables[element.id].true_value.order) {
          this.turnSelectErrorOn(`#${element.id}-true_value-order`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'letter_sent_date' && this.lettervariables[element.id].false_value.letters.length < 1) {
          this.turnSelectErrorOn(`#${element.id}-false_value-send_letters`)
          this.emptyMappableTrueFalseValue = true
        }
        if (this.lettervariables[element.id].false_value.variable === 'letter_sent_date' && !this.lettervariables[element.id].false_value.order) {
          this.turnSelectErrorOn(`#${element.id}-false_value-order`)
          this.emptyMappableTrueFalseValue = true
        }
      })
    },
    changeVariable(delay, moduleId, event, variable, index, vr) {
      if (delay) {
        setTimeout(() => {
          this.runChangeVariables(moduleId, event, variable, index, vr)
        }, 2000)
      } else {
        this.runChangeVariables(moduleId, event, variable, index, vr)
      }
    },
    runChangeVariables(moduleId, event, variable, index, vr) {
      if (vr) {
        variable.fields = []
      }
      // this.$el.querySelector(`.letter-template-${moduleId}-${variable.id}`).classList.remove('inputErrorClass')
      if (this.newCustomVariables[index] && this.newCustomVariables[index].mappable.value) {
        document.getElementById(`conditional-mappable-${moduleId}-${variable.id}`).style.display = 'none'
        this.newCustomVariables[index].mappable.value = false
      }
      if (event === 'dato_felt') {
        document.getElementById(`div-wrapper-${moduleId}-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`run-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`date-${moduleId}-${variable.id}`).style.display = 'block'
        document.getElementById(`interestrate-percentage-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${moduleId}-${variable.id}`).style.display = 'none'
        this.lettervariables[`${moduleId}-${variable.id}`] = {
          variable: event,
          functional_value: 0,
        }
      } else if (event === 'interest_rate_percentage') {
        document.getElementById(`div-wrapper-${moduleId}-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${moduleId}-${variable.id}`).style.display = 'block'
        document.getElementById(`letter-sent-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${moduleId}-${variable.id}`).style.display = 'none'
        this.lettervariables[`${moduleId}-${variable.id}`] = {
          variable: event,
          functional_value: null,
          base_types: [],
          document_order: null,
        }
      } else if (event === 'debtia.currencyConverter') {
        /* if (this.prevModuleOptions.length === 0) {
          this.getPreviousModules()
        } */
        document.getElementById(`div-wrapper-${moduleId}-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${moduleId}-${variable.id}`).style.display = 'block'
        document.getElementById(`run-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${moduleId}-${variable.id}`).style.display = 'none'
        this.lettervariables[`${moduleId}-${variable.id}`] = {
          variable: event,
          functional_value: null,
          currency_id: null,
          statement_id: null,
          statement_type: null,
        }
      } else if (event === 'module_run_date') {
        if (this.prevModuleOptions.length === 0) {
          this.getPreviousModules(this.processModule.index)
        }
        document.getElementById(`div-wrapper-${moduleId}-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${moduleId}-${variable.id}`).style.display = 'block'
        document.getElementById(`interestrate-percentage-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${moduleId}-${variable.id}`).style.display = 'none'
        this.lettervariables[`${moduleId}-${variable.id}`] = {
          variable: event,
          functional_value: 0,
        }
      } else if (event === 'condition_mappable') {
        this.lettervariables[`${moduleId}-${variable.id}`] = { ...this.componentObject }
        document.getElementById(`div-wrapper-${moduleId}-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${moduleId}-${variable.id}`).style.display = 'none'
        this.newCustomVariables[index].mappable.value = true
        setTimeout(() => {
          document.getElementById(`conditional-mappable-${moduleId}-${variable.id}`).style.display = 'block'
        }, 50)
        // this.conditionalLetterVar = this.lettervariables[variable.id]
        setTimeout(() => {
          this.$refs[`conditionalChild-${moduleId}-${variable.id}`][0].mappable_validation_fields[variable.id] = ['condition_id', 'condition_operator_id']
        }, 500)
      } else if (event === 'letter_sent_date' || event === 'debtia.case_presentation') {
        document.getElementById(`div-wrapper-${moduleId}-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${moduleId}-${variable.id}`).style.display = 'block'
        document.getElementById(`letter-sent-date-order-${moduleId}-${variable.id}`).style.display = event === 'letter_sent_date' ? 'block' : 'none'
        document.getElementById(`case-presentation-statements-${moduleId}-${variable.id}`).style.display = event === 'debtia.case_presentation' ? 'block' : 'none'
        document.getElementById(`payment-link-${moduleId}-${variable.id}`).style.display = 'none'

        document.getElementById(`free-text-${moduleId}-${variable.id}`).style.display = 'none'
        this.lettervariables[`${moduleId}-${variable.id}`] = {
          variable: event,
          functional_value: null,
          letters: [],
          order: null,
        }
      } else if (event === 'debtia.freeText') {
        document.getElementById(`div-wrapper-${moduleId}-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${moduleId}-${variable.id}`).style.display = 'block'
        document.getElementById(`payment-link-${moduleId}-${variable.id}`).style.display = 'none'
        this.lettervariables[`${moduleId}-${variable.id}`] = {
          variable: event,
          functional_value: null,
          free_text_note: null,
        }
      } else if (event === 'debtia.paymentLink') {
        document.getElementById(`div-wrapper-${moduleId}-${variable.id}`).classList.add('div-wrapper')
        document.getElementById(`date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`free-text-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${moduleId}-${variable.id}`).style.display = 'block'
        this.newCustomVariables[variable.id] = {
          variable: event,
          functional_value: null,
          module_type: this.processModule.module_id === 3 ? 'letter' : 'email',
          period_based_plan: this.periodBasePlan,
          amount_based_plan: this.amountBasePlan,
          max_months: this.maxMonth,
          min_amount: this.minAmount,
          interest_free_months: this.interestFreeMonths,
          payment_date: this.installmentStartDate,
          template_id: this.paymentEmailTemplate,
          employee_name: JSON.parse(localStorage.getItem('userData')).data.name,
        }
      } else {
        const customVar = this.templateVariableOptions.filter(e => e.value === event && e.custom_variable === true)
        this.lettervariables[`${moduleId}-${variable.id}`] = customVar.length > 0 ? {
          variable: event,
          functional_value: null,
          custom_variable: true,
        } : event
        document.getElementById(`div-wrapper-${moduleId}-${variable.id}`).classList.remove('div-wrapper')
        document.getElementById(`date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`currency-conversion-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`run-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`interestrate-percentage-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`letter-sent-date-${moduleId}-${variable.id}`).style.display = 'none'
        document.getElementById(`payment-link-${moduleId}-${variable.id}`).style.display = 'none'
      }
      const emptyValues = this.newCustomVariables.filter(element => !this.lettervariables[`${moduleId}-${element.id}`])
      if (emptyValues.length === 0) {
        this.errorMsg = false
      }
      this.getTheObject(this.processModule.condition, this.processModule.depends_on)
    },
    assignClass(field) {
      let exists = false
      const entry = this.specialOptions.filter(e => e.name === field)
      if (entry.length > 0) {
        exists = true
      }
      return exists
    },
    async getPreviousModules(index) {
      this.showPrevModuleOptions = this.prevModuleOptions
        .slice(0, index)
    },
    changeTemplateVariables(id) {
      this.currentTemplateId = id
      this.currentTemplateTitle = this.findLabelByValue(id)
      if (this.currentModule === 3) {
        this.processModule.module_settings.letter_template_id = id
        this.processModule.module_settings.letter_template_title = this.findLabelByValue(id)
        this.changeLetterTemplateVariables(id)
      } else {
        this.processModule.module_settings.email_template_id = id
        this.processModule.module_settings.email_template_title = this.findLabelByValue(id)
        this.changeEmailTemplateVariables(id)
      }
    },
    changeEmailTemplateVariables(id) {
      this.busy = true
      this.newCustomVariables = []
      const url = `/template/get-template-vars-api/${id}`
      const headers = {
        clientId: this.clientId,
        secret: this.secret,
      }
      axiosEmail.get(url, {
        headers,
      }).then(response => {
        if (response.status === 200) {
          setTimeout(() => {
            this.busy = false
            // this.letterTemplateTitle = response.data.data.data.name
            const object = response.data.data.template_custom_fields
            object.forEach(element => {
              const obj = {
                id: element.custom_field,
                value: '',
                field: null,
                fields: [],
                mappable: {
                  value: false,
                  data: { ...this.componentObject },
                },
              }
              this.newCustomVariables.push(obj)
            })
            this.checkValuesWithPreviousVariables()
            // this.attachVariables()
          }, 3000)
        }
      })
    },
    changeLetterTemplateVariables(id) {
      this.busy = true
      this.newCustomVariables = []
      // this.templateVariables = []
      // this.emailvariables = {}
      // this.templateVariableOptions = []
      const url = `/letters-api/view-letter?templateID=${id}`
      const headers = {
        clientId: this.clientId,
        secret: this.secret,
      }
      axiosletter.get(url, {
        headers,
      }).then(response => {
        if (response.status === 200) {
          setTimeout(() => {
            this.busy = false
            // this.letterTemplateTitle = response.data.data.data.name
            const object = response.data.data.apiBody.customFields
            for (const [key] of Object.entries(object)) {
              const obj = {
                id: key,
                value: '',
                field: null,
                fields: [],
                mappable: {
                  value: false,
                  data: { ...this.componentObject },
                },
              }
              this.newCustomVariables.push(obj)
            }
            this.checkValuesWithPreviousVariables()
            // this.attachVariables()
          }, 3000)
        }
      })
    },
    checkValuesWithPreviousVariables() {
      this.previousTemplateVars.push(...this.newCustomVariables)
      const previousObject = this.previousTemplateVars
      const newObject = this.newCustomVariables
      const moduleId = this.processModule.id
      newObject.forEach((element, index) => {
        const matchingElement = previousObject.find(item => item.id === element.id)
        if (matchingElement) {
          this.newCustomVariables[index] = matchingElement
          this.changeVariable(1, moduleId, matchingElement.value, element, index, null)
        }
      })
      this.processModule.newCustomVariables = this.newCustomVariables
    },
    createDefaultYesNo(moduleId, obj, vari, type) {
      this.$refs[`conditionalChild-${moduleId}-${vari}`][0].defaultYesnoValueChanged(obj, type)
    },
    removeErrorBorder(id, select) {
      if (select) {
        const dropdown = document.getElementById(`${id}`)
        const selector = dropdown.querySelector('.vs__dropdown-toggle')
        selector.classList.remove('inputErrorClassField')
      } else {
        const selector = document.getElementById(id)
        selector.classList.remove('inputErrorClassField')
      }
    },
    updateInstallmentPlanFields(data, id, key, index) {
      // This condition is used to check if the user has input a value in the min_amount field
      // that is less than 100. If the condition is true, we show an error message and prevent the
      // user from saving the page.
      if (key === 'min_amount') {
        if (parseInt(data, 10) < 100) {
          this.minAmountError = true
        } else {
          this.minAmountError = false
        }
      }
      // This condition is used to check if the user has input a value in the max_months field
      // that is less than 1. If the condition is true, we show an error message and prevent the
      // user from saving the page.
      if (key === 'max_months') {
        if (parseInt(data, 10) < 1) {
          this.maxMonthsError = true
        } else {
          this.maxMonthsError = false
        }
      }
      // This condition is used to check if the user has input a value in the interest_free_months field
      // that is less than 1 or greater than 3. If the condition is true, we show an error message and
      // prevent the user from saving the page.
      if (key === 'interest_free_months') {
        if (parseInt(data, 10) < 0) {
          this.interestFreeMonthsError = true
        } else {
          this.interestFreeMonthsError = false
        }
      }

      this.newCustomVariables[id][key] = data

      if (key === 'amount_based_plan') {
        const minAmountElement = document.getElementById(`col-min_amount-${this.processModule.id}-${id}`)
        minAmountElement.style.display = this.newCustomVariables[id][key] ? 'block' : 'none'
        // eslint-disable-next-line dot-notation
        // this.newCustomVariables[id]['min_amount'] = null
        this.newCustomVariables[index].fields[1] = null
      }

      if (key === 'period_based_plan') {
        const maxMonthsElement = document.getElementById(`col-max_months-${this.processModule.id}-${id}`)
        maxMonthsElement.style.display = this.newCustomVariables[id][key] ? 'block' : 'none'
        this.newCustomVariables[index].fields[3] = null
      }

      if (key === 'amount_based_plan' || key === 'period_based_plan') {
        const interestFreeMonthsElement = document.getElementById(`col-interest_free_months-${this.processModule.id}-${id}`)
        interestFreeMonthsElement.style.display = (this.newCustomVariables[id].amount_based_plan || this.newCustomVariables[id].period_based_plan) ? 'block' : 'none'
        const paymentDateElement = document.getElementById(`col-payment_date-${this.processModule.id}-${id}`)
        paymentDateElement.style.display = (this.newCustomVariables[id].amount_based_plan || this.newCustomVariables[id].period_based_plan) ? 'block' : 'none'
      }
      this.getTheObject(this.processModule.condition, this.processModule.depends_on)
    },
  },
}
</script>

<style lang="scss">
  .emailSubmitBtn {
    width: 100%;
  }

  .inputErrorClass .vs__dropdown-toggle{
    border-color: red !important;
  }

  .inputErrorClassField{
    border-color: red !important;
  }

  #fieldserror {
    color: red;
  }

  .showdates {
    display: none;
    margin-top: 10px;
  }

  .autofik {
    margin-left: -10px;
    width: 106%;
    border-radius: 4px;
    padding: 10px;
    color: white;
    background-color: #5fb3ac !important;
    box-shadow: 1px 1px 2px #d3e8e6, 0 0 15px #d3e8e6, 0 0 2px #d3e8e6;
  }

  div.div-wrapper {
    border: 1px solid #d8d6de;
    border-radius: 5px;
    padding: 10px 10px 0px 10px;
  }

  .variables-row .variable-col:nth-child(-n+2) {
    /* Apply styles to the first 2 elements */
    margin-top: 10px;
  }

  .amount-period-base-divs {
    padding: 15px 0px 5px 0px;
    border: 1px solid #d8d6dd;
    margin: 0px 15px 15px 15px;
    border-radius: 10px;
  }
</style>
